"use client";

import React from "react";
import { ExtensionCheckNav } from "./ExtensionCheckNav";

export function HeaderNav() {
  return (
    <nav className="flex flex-row w-full justify-end">
      {/* <div className="flex flex-row space-x-4 items-center">
        <ExtensionCheckNav />
      </div> */}
    </nav>
  );
}
